module.exports = __webpack_public_path__ + "img/1532465586.fd7f1f92.jpg";